const REMOVE_TOAST = Symbol('REMOVE_TOAST')

const INITIAL_STATE = {
  toast: null,
}

export const ACTION_TYPES = ['UPDATE_OBJECT_REJECTED']

export default (state = INITIAL_STATE, action) => {
  if (action.type === REMOVE_TOAST) {
    return {
      toast: null,
    }
  }

  for (const actionType of ACTION_TYPES) {
    if (action.type === actionType) {
      return {
        toast: {
          id: Date.now(),
          body: 'Action Cannot Be Completed',
        },
      }
    }
  }

  return state
}

// Actions

export const removeToast = () => ({
  type: REMOVE_TOAST,
})

// Selectors

export const getCurrentToast = state => {
  return state.toasts.toast
}
